import { getMajorVersion } from '@repo/utils';
import useTaxaOverTime, {
  TaxaOverTimeData,
} from 'services/insights/useTaxaOverTime';

type Props = {
  kitId?: string;
  metricId?: number;
};

type ReturnType = {
  data: TaxaOverTimeData[];
  isLoading: boolean;
  currentKitVersion: number | null;
  hasMultipleVersions: boolean;
};

export default function useGetMaturationTaxaOverTime({
  kitId,
  metricId,
}: Props): ReturnType {
  const { data, isLoading } = useTaxaOverTime({ kitId, metricId });

  if (!data)
    return {
      data: [],
      isLoading,
      currentKitVersion: null,
      hasMultipleVersions: false,
    };

  const currentKitData = data.find(k => k.kit_id === kitId);
  const currentKitDataVersion = getMajorVersion(currentKitData?.version ?? '');

  const filteringLogic =
    currentKitDataVersion === 5
      ? (k: TaxaOverTimeData) => getMajorVersion(k.version) === 5
      : (k: TaxaOverTimeData) => getMajorVersion(k.version) <= 4;

  const filteredData = data.filter(filteringLogic);

  return {
    data: filteredData,
    isLoading,
    currentKitVersion: currentKitDataVersion,
    hasMultipleVersions: filteredData.length !== data.length,
  };
}
